import { Component, OnInit, AfterViewChecked, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenicationService } from '../../_services/authenication.service';
import { EventsService } from "../../_services/events.service";
import { CmsService } from "../../_services/cms.service";
import { S3uploadsService } from './../../_services/s3uploads.service'
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import {ContactusService} from "../../_services/contactus.service";
import {CommunityService} from "../../_services/community.service";
import { IDayCalendarConfig } from "ng2-date-picker";
import { DynamicScriptLoaderServiceService } from "../../_services/dynamic-script-loader-service.service";
import { RegionService } from '../../_services/region.service';
import { DoctorService } from '../../_services/doctor.service';
declare const tinymce: any;

@Component({
  selector: 'app-add-event',
  templateUrl: './add-event.component.html',
  styleUrls: ['./add-event.component.css']
})
export class AddEventComponent implements OnInit {

  addEventForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  events: any[] = [];
  selectedfile1: Array<File> = [];
  selectedfile2: Array<File> = [];
  dropdownSettings: any = {};
  // selectedfile3: Array<File> = [];
  // selectedfile4: Array<File> = [];
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';
  userid: string;
  imageData: string;
  thumbnailData: string;
  urls = new Array<string>();
  urls1 = new Array<string>();

  regionList: any[] = [];
  communityList: any[] = [];
  facilitatorList: any[] = [];
  contactlist: any[] = [];
  selectedType: "BOAT";
  videos = ['video/x-flv', 'video/mp4', 'video/3gpp', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv', 'video/mpeg', 'video/webm'];
  images = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
  organisationDropdownData = [];
  selectedOrganisation  = [];
  selectedOrganisationRoot  = [];
  public dayPickerConfig = <IDayCalendarConfig>{
    format: "YYYY-MM-DD",
    monthFormat: "MMMM, YYYY",
    firstDayOfWeek: "mo",
  };

  confg = {
    height: 500,
    menubar: false,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help wordcount',
      'image'
    ],
    toolbar:
      'undo redo | formatselect | bold italic backcolor | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | removeformat | image | help',
    /* enable title field in the Image dialog*/
    image_title: true,
    /* enable automatic uploads of images represented by blob or data URIs*/
    automatic_uploads: true,
    file_picker_types: 'image',
    /* and here's our custom image picker*/
    file_picker_callback: function (cb, value, meta) {
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');

      /*
        Note: In modern browsers input[type="file"] is functional without
        even adding it to the DOM, but that might not be the case in some older
        or quirky browsers like IE, so you might want to add it to the DOM
        just in case, and visually hide it. And do not forget do remove it
        once you do not need it anymore.
      */

      input.onchange = function () {
        let file = (<HTMLInputElement>this).files[0];

        var reader = new FileReader();
        reader.onload = function () {
          /*
            Note: Now we need to register the blob in TinyMCEs image blob
            registry. In the next release this part hopefully won't be
            necessary, as we are looking to handle it internally.
          */
          var id = 'blobid' + (new Date()).getTime();
          var blobCache = tinymce.activeEditor.editorUpload.blobCache;
          var base64 = (<string>reader.result).split(',')[1];
          var blobInfo = blobCache.create(id, file, base64);
          blobCache.add(blobInfo);
          console.log(blobInfo);

          /* call the callback and populate the Title field with the file name */
          //cb(blobInfo.blobUri(), { title: file.name });
          cb(blobInfo.blobUri(), { title: file.name });
        };
        reader.readAsDataURL(file);
      };

      input.click();
    }
  };

  constructor(private formBuilder: FormBuilder, private doctorservice: DoctorService, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private eventsservice: EventsService, private spinnerService: Ng4LoadingSpinnerService, private regionService: RegionService,private CommunityService: CommunityService, private cmsService: CmsService, private S3uploadsService: S3uploadsService, private contactusservice: ContactusService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    DynamicScriptLoaderServiceService.loadDynamicScript('assets/assets/dist/js/selectpicker.js');

    this.userid = this.userdetaild['_id'];
    this.getRegions();
    this.getCommunityList();
    this.getFacilitatorList();

    this.addEventForm = this.formBuilder.group({
      event_type:['', null],
      event_title: ['', [Validators.required, Validators.minLength(3)]],
      event_description: ['', this.selectedType === "BOAT" ? [Validators.required] : null],
      // event_price_title: [''],
      // event_price_description: [''],
      // expected_title: [''],
      // expected_learnings: [''],
      // event_agenda_title: [''],
      // event_agenda: [''],
      // event_review_title: [''],
      // event_review: [''],
      keyword: [''],
      region: ['', [Validators.required]],
      facilitator: ['', [Validators.required]],
      community: ['', [Validators.required]],
      keyword_type: [''],
      type: ['', [Validators.required]],
      url: ['', [Validators.required]],
      video_thumbnail: ['', this.selectedType === "BOAT" ? [Validators.required] : null],
      video: ['', this.selectedType === "BOAT" ? [Validators.required] : null],
      images: ['', this.selectedType === "BOAT" ? [Validators.required] : null],
      thumbnail: ['', this.selectedType === "BOAT" ? [Validators.required] : null],
      event_category: ['', [Validators.required]],
      event_location: [''],
      event_price: ['', [Validators.required]],
      event_city: [''],
      event_date: ['', [Validators.required]],
      event_end_date: ['', [Validators.required]],
      event_start: [''],
      event_end: [''],
      event_total: ['', [Validators.required]],
      event_status: ['true', [Validators.required]],
      // event_corporate: [''],
      organisation: ['', [Validators.required]],
      event_edm: [''],
    });
    this.setpreLoadedData();

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  onSelectAll(items: any) {
    items.map(item=>{
      if(!this.selectedOrganisation.includes(this.contactlist[this.organisationDropdownData.indexOf(item)]['_id'])){
        this.selectedOrganisation.push(this.contactlist[this.organisationDropdownData.indexOf(item)]['_id']);
      }
      if(!this.selectedOrganisationRoot.includes(this.contactlist[this.organisationDropdownData.indexOf(item)]['_id'])){
        this.selectedOrganisationRoot.push(this.contactlist[this.organisationDropdownData.indexOf(item)]['_id']);
      }
    })
  }

  onRegionSelect(item:any){
    this.selectedOrganisation=[];
    this.selectedOrganisationRoot=[];
   this.getActiveOrgsForRegion(this.addEventForm.controls.region.value);
  }

  onItemSelect(item:any){
   this.selectedOrganisation.push(this.contactlist[this.organisationDropdownData.indexOf(item)]['_id']);
   this.selectedOrganisationRoot.push(this.contactlist[this.organisationDropdownData.indexOf(item)]['_id']);
  }
  OnItemDeSelect(item:any){
    this.selectedOrganisation.splice(this.selectedOrganisation.indexOf(this.contactlist[this.organisationDropdownData.indexOf(item)]['_id']),1);
    this.selectedOrganisationRoot.splice(this.selectedOrganisationRoot.indexOf(this.contactlist[this.organisationDropdownData.indexOf(item)]['_id']),1);
  }

  get f() { return this.addEventForm.controls; }

  fileUpload(event) {
    this.urls = [];
    this.selectedfile1 = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile1.length; i++) {
      if (this.images.includes(this.selectedfile1[i].type)) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls.push(e.target.result);
        };
        console.log(this.selectedfile1[i]);
        console.log(this.urls);
        reader.readAsDataURL(this.selectedfile1[i]);
      } else {
        this.addEventForm.controls.images.reset();
        this.toaster.showError('File Type', 'Only Images are allowed');
        return false;
      }
    }
  }
  typeChanged(value) {
    this.selectedType = value;
  }
  fileUpload1(event) {
    this.urls1 = [];
    this.selectedfile2 = event.target.files as Array<File>;
    for (let i = 0; i < this.selectedfile2.length; i++) {
      if (this.images.includes(this.selectedfile2[i].type)) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls1.push(e.target.result);
        };
        console.log(this.selectedfile2[i]);
        console.log(this.urls1);
        reader.readAsDataURL(this.selectedfile2[i]);
      } else {
        this.addEventForm.controls.thumbnail.reset();
        this.toaster.showError('File Type', 'Only Images are allowed');
        return false;
      }



    }
  }

  // fileUpload2(event) {
  //   this.selectedfile3 = event.target.files as Array<File>;
  //   for (let i = 0; i < this.selectedfile3.length; i++) {
  //     if (!this.images.includes(this.selectedfile3[i].type)) {
  //       this.addEventForm.controls.video_thumbnail.reset();
  //       this.toaster.showError('File Type', 'Only Images are allowed');
  //       return false;
  //     }
  //   }
  // }

  // fileUpload3(event) {
  //   this.selectedfile4 = event.target.files as Array<File>;
  //   for (let i = 0; i < this.selectedfile4.length; i++) {
  //     if (!this.videos.includes(this.selectedfile4[i].type)) {
  //       this.addEventForm.controls.video.reset();
  //       this.toaster.showError('File Type', 'Only Videos are allowed');
  //       return false;
  //     }
  //   }
  // }


  setpreLoadedData() {
    const data = sessionStorage.getItem("eventData");
    if (data) {
      this.events = JSON.parse(data);
      const resultantSelectedOrganisations = [];
      this.events['organisation'].map(orgId=>{
        this.selectedOrganisation.push(orgId)
        this.contactlist.map(org=>{
          if(org['_id']===orgId){
            this.organisationDropdownData.splice(this.organisationDropdownData.indexOf(org["name"]),1);
            resultantSelectedOrganisations.push({id:org["id"],text:org["name"], isDisabled:true})
          }
        })
      });

      this.selectedType = this.events['type'];
      this.selectedOrganisationRoot = resultantSelectedOrganisations;
        this.addEventForm.setValue({
          event_type: this.events['type'],
          organisation: "",
          event_title: this.events['event_title'],
          event_description: (this.events['description'])?this.events['description']:this.events['event_description'] ? this.events['event_description'] : "",
          event_location: this.events['event_location'] ? this.events['event_location'] : "",
          event_category: (this.events['event_category']) ? this.events['event_category'] : '',
          event_price: this.events['event_price'] ? this.events['event_price'] : "",
          event_city: this.events['event_city'] ? this.events['event_city'] : "",
          images: '',
          thumbnail: '',
          event_date: this.events['event_date'] ? this.events['event_date'] : "",
          event_end_date: (this.events['event_end_date']) ? this.events['event_end_date'] : '',
          event_start: (this.events['event_start']) ? this.events['event_start'] : '',
          event_end: (this.events['event_end']) ? this.events['event_end'] : '',
          event_edm: (this.events['event_edm']) ? this.events['event_edm'] : '',
          event_status: (this.events['event_status']) ? this.events['event_status'].toString() : 'false',
          region: (this.events['region']) ? this.events['region'] : '',
          community: (this.events['community']) ? this.events['community'] : '',
          facilitator: (this.events['facilitator']) ? this.events['facilitator'] : '',
          keyword: (this.events['keyword']) ? this.events['keyword'] : '',
          keyword_type: (this.events['keyword_type']) ? this.events['keyword_type'] : '',
          type: (this.events['meeting_details']) ? this.events['meeting_details']['type'] : (this.events['type']) ? this.events['type'] : '',
          url: (this.events['meeting_details']) ? this.events['meeting_details']['url'] : (this.events['url']) ? this.events['url'] : '',
          video_thumbnail: (this.events['video_thumbnail']) ? this.events['video_thumbnail'] : '',
          video: (this.events['video']) ? this.events['video'] : '',
          // event_corporate: (this.events['event_corporate']) ? this.events['event_corporate'] : 'false',
          event_total: this.events['event_total'] ? this.events['event_total'] : "",
        });
    }
    sessionStorage.clear();
  }


  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    //console.log(this.addEventForm.invalid);
    // stop here if form is invalid
    if (this.addEventForm.invalid) {
      console.log(this.addEventForm);
      
      this.spinnerService.hide();
      return;
    }

    let card = [];

    const addPayload = {
      event_type: "BOAT",
      event_title: this.addEventForm.controls.event_title.value,
      event_description: btoa(this.addEventForm.controls.event_description.value),
      region: this.addEventForm.controls.region.value,
      facilitator: this.addEventForm.controls.facilitator.value,
      community: this.addEventForm.controls.community.value,
      keyword: (this.addEventForm.controls.keyword.value)?this.addEventForm.controls.keyword.value:'',
      keyword_type: (this.addEventForm.controls.keyword_type.value)?this.addEventForm.controls.keyword_type.value:'',
      type: this.addEventForm.controls.type.value,
      url: this.addEventForm.controls.url.value,
      event_price_description: this.addEventForm.controls.event_description.value,
      expected_learnings: btoa(this.addEventForm.controls.event_description.value),
      event_agenda: btoa(this.addEventForm.controls.event_description.value),
      event_review: btoa(this.addEventForm.controls.event_description.value),
      event_category: this.addEventForm.controls.event_category.value.toString(),
      event_location: (this.addEventForm.controls.event_location.value) ? this.addEventForm.controls.event_location.value : '',
      event_price: this.addEventForm.controls.event_price.value,
      event_city: (this.addEventForm.controls.event_city.value) ? this.addEventForm.controls.event_city.value : '',
      event_date: this.addEventForm.controls.event_date.value,
      event_end_date: this.addEventForm.controls.event_end_date.value,
      event_start: this.addEventForm.controls.event_start.value,
      event_end: this.addEventForm.controls.event_end.value,
      event_total: this.addEventForm.controls.event_total.value,
      event_status: this.addEventForm.controls.event_status.value,
      event_edm: btoa(this.addEventForm.controls.event_description.value),
      event_corporate: 'true',
      video_thumbnail: this.addEventForm.controls.video_thumbnail.value,
      organisation: this.selectedOrganisation.join(","),
      video: this.addEventForm.controls.video.value,
      images: (this.imageData) ? this.imageData : '',
      thumbnail: (this.thumbnailData) ? this.thumbnailData : '',
      userid: this.userid,
      cards: JSON.stringify(card)
    };

    // console.log('form data',addPayload);
    // console.log('file1',this.selectedfile1);
    // console.log('file2',this.selectedfile2);
    // console.log('file3',this.selectedfile3);
    // console.log('file4',this.selectedfile4);
    // return;

    const formdata = new FormData();
    formdata.append('event_title', addPayload.event_title);
    formdata.append('event_type', addPayload.event_type);
    formdata.append('event_category', addPayload.event_category);
    formdata.append('event_description', addPayload.event_description);
    formdata.append('event_price_description', addPayload.event_price_description);
    formdata.append('expected_learnings', addPayload.expected_learnings);
    formdata.append('event_agenda', addPayload.event_agenda);
    formdata.append('event_review', addPayload.event_review);
    formdata.append('event_location', addPayload.event_location);
    formdata.append('event_price', addPayload.event_price);
    formdata.append('event_city', addPayload.event_city);
    formdata.append('event_date', addPayload.event_date);
    formdata.append('event_end_date', addPayload.event_end_date);
    formdata.append('event_start', addPayload.event_start);
    formdata.append('event_end', addPayload.event_end);
    formdata.append('event_total', addPayload.event_total);
    formdata.append('event_status', addPayload.event_status);
    formdata.append('event_corporate', addPayload.event_corporate);
    formdata.append('event_edm', addPayload.event_edm);
    formdata.append('keyword', addPayload.keyword);
    formdata.append('keyword_type', addPayload.keyword_type);
    formdata.append('type', addPayload.type);
    formdata.append('url', addPayload.url);
    formdata.append('cards', addPayload.cards);
    formdata.append('region', addPayload.region);
    formdata.append('community', addPayload.community);
    formdata.append('facilitator', addPayload.facilitator);
    formdata.append('video_thumbnail', addPayload.video_thumbnail);
    formdata.append('organisation', addPayload.organisation);
    formdata.append('video', addPayload.video);
    formdata.append('userid', this.userid);
    if (addPayload.images) {
      formdata.append('images', addPayload.images);
    }
    if (this.selectedfile2) {
      formdata.append('thumbnail', addPayload.thumbnail);
    }
    

    // if (this.selectedfile3) {
    //   const files: Array<File> = this.selectedfile3;
    //   for (let i = 0; i < files.length; i++) {
    //     formdata.append('video_thumbnail', files[i], files[i].name);
    //   }
    // }

    // if (this.selectedfile4) {
    //   const files: Array<File> = this.selectedfile4;
    //   for (let i = 0; i < files.length; i++) {
    //     formdata.append('video', files[i], files[i].name);
    //   }
    // }
    this.addEvents(addPayload);

  }


  addEvents(payload) {
    this.eventsservice.addEvents(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.router.navigate(['/events-list']);
          } else {
            this.toaster.showError('Add Events', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Add Events', error.error.ResponseMessage);
        });
  }

  getRegions() {
    this.regionService.getRegions()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.regionList = data.Data;
          }
        },
        error => {
          console.log('Region', error);
        });
  }

  getCommunityList() {
    this.CommunityService.listCommunities()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.communityList = data.communityData;
          }
        },
        error => {
          console.log('Club', error);
        });
  }

  getFacilitatorList() {
    this.doctorservice.getDoctorsByStatus({status: true})
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.facilitatorList = data.doctorsList;
          }
        },
        error => {
          console.log('Facilitator', error);
        });
  }

  fileUploads(event) {
    let selectedfile = event.target.files[0];
    console.log(selectedfile);
    this.uploadFiles(selectedfile);
  }

  fileUploads1(event) {
    let selectedfile = event.target.files[0];
    console.log(selectedfile);
    this.uploadFiles1(selectedfile);
  }



  uploadFiles(filedata) {
    this.S3uploadsService.getSigendUrl({ filename: filedata.name, type: "EVENTS" })
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let details = data.urlDetails;
            this.imageData = details.url;
            this.uploadFileViaUri(details.uri, filedata)
          } else {
            this.toaster.showError('Add Events', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Add Events', error.error.ResponseMessage);
        });
    // this.cmsService.generateSignedUrl(payload)
    //   .subscribe(
    //     (data: any) => {
    //       if (data && data.ResponseCode === '200') {
    //         let details = data.Data;
    //         this.imageData = details.url;
    //         this.uploadFileViaUri(details.uri, filedata)
    //       } else {
    //         this.toaster.showError('Add Events', data.ResponseMessage);
    //       }
    //     },
    //     error => {
    //       this.toaster.showError('Add Events', error.error.ResponseMessage);
    //     });
  }

  uploadFiles1(filedata) {
    this.S3uploadsService.getSigendUrl({ filename: filedata.name, type: "EVENTS" })
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let details = data.urlDetails;
            this.thumbnailData = details.url;
            this.uploadFileViaUri(details.uri, filedata)
          } else {
            this.toaster.showError('Add Events', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Add Events', error.error.ResponseMessage);
        });
  }

  uploadFileViaUri(uri, payload) {
    this.cmsService.uploadFileViaUri(uri, payload)
      .subscribe(
        (data: any) => {
          // this.toaster.showError('Edit Events', "Image uploaded");
        },
        error => {
          this.toaster.showError('Edit Events Error', error);
        });
  }

  getActiveOrgsForRegion(region) {

    this.contactusservice.getActiveOrgsForRegion({regionId:region})
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.contactlist = data.Data;
            const resultantOrganisation=[];
            data.Data.map(org=>{
              resultantOrganisation.push(org['name'])
            })
            this.organisationDropdownData = resultantOrganisation;
          }
        },
        error => {
          console.log(error)
          // this.toaster.showError('Users', error);
          
        });
  }





}
